import { useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';

export function useGenerateLinkForPagination() {
  const [searchParams] = useSearchParams();

  return useCallback(
    (nextPage: number, slug?: string) => {
      const params = new URLSearchParams(searchParams);
      if (nextPage > 1) {
        params.set(slug ? `${slug}-page` : 'page', nextPage.toString());
      } else {
        params.delete(slug ? `${slug}-page` : 'page');
      }
      const searchString = params.toString();
      return {
        search: searchString ? searchString : undefined,
      };
    },
    [searchParams],
  );
}
